import { css, Stack, styled, Typography } from '@mui/material';

import { Button } from '@braskai/ui-kit';

export const SContainer = styled(Stack)(
  () => css`
    min-height: 100vh;
    align-items: center;
    justify-content: center;
  `,
);

export const SErrorImage = styled('img')(
  () => css`
    width: 231px;
    height: 133px;
  `,
);

export const STitle = styled(Typography)(
  () => () => css`
    margin-top: 12px;
  `,
);

export const SText = styled(Typography)(
  () => css`
    margin-top: 4px;
    text-align: center;
  `,
);

export const SRefreshPageButton = styled(Button)(
  () => css`
    margin-top: 24px;
  `,
);
